
<template>
  <b-overlay :show="isLoading" rounded="sm">
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-6">
            <dl class="row mb-0 font-size-14">

              <dt class="col-sm-3">Partida</dt>
              <dd class="col-sm-8"><strong>: {{ data.codigo_partida +" " +  data.partida }}</strong></dd>

              <dt class="col-sm-3">Unidad Medida</dt>
              <dd class="col-sm-8"><strong>: {{ data.unidad_medida}}</strong></dd>

              <dt class="col-sm-3">Cantidad</dt>
              <dd class="col-sm-8"><strong>: {{data.cantidad}}</strong></dd>

              <dt class="col-sm-3">Costo Unitario</dt>
              <dd class="col-sm-8"><strong> : S/ {{data.costo_unitario}} </strong></dd>

              <dt class="col-sm-3">Subtotal</dt>
              <dd class="col-sm-8"><strong>: S/ {{data.subtotal}}</strong></dd>

              <dt class="col-sm-3">Cantidad MM</dt>
              <dd class="col-sm-8"><strong>: {{data.cantidad_mayor_metrado}}</strong></dd>

              <dt class="col-sm-3">Subtotal MM</dt>
              <dd class="col-sm-8"><strong>: S/ {{data.subtotal_mayor_metrado}}</strong></dd>

            </dl>
          </div>
          <div class="col-md-6">
            <dl class="row mb-0 font-size-8">
              <dt class="col-sm-3">ID</dt>
              <dd class="col-sm-8">: {{data.partida_id}}</dd>

              <dt class="col-sm-3" v-show="data.t1">Titulo 1</dt>
              <dd class="col-sm-8" v-show="data.t1">: {{data.t1}}</dd>

              <dt class="col-sm-3" v-show="data.t2">Titulo 2</dt>
              <dd class="col-sm-8" v-show="data.t2">: {{data.t2}}</dd>

              <dt class="col-sm-3" v-show="data.t3">Titulo 3</dt>
              <dd class="col-sm-8" v-show="data.t3">: {{data.t3}}</dd>

              <dt class="col-sm-3" v-show="data.t4">Titulo 4</dt>
              <dd class="col-sm-8" v-show="data.t4">: {{data.t4}}</dd>

              <dt class="col-sm-3" v-show="data.t5">Titulo 5</dt>
              <dd class="col-sm-8" v-show="data.t5">: {{data.t5}}</dd>

              <dt class="col-sm-3" v-show="data.t6">Titulo 6</dt>
              <dd class="col-sm-8" v-show="data.t6">: {{data.t6}}</dd>

            </dl>
          </div>


        </div>

        <b-tabs  card  v-model="tabIndex">
          <b-tab title="Hoja de metrado" >
            <!--<button v-on:click="changeCellType">CLick</button>-->
            <div class="row">
              <div class="col-md-10">
                <button type="button"
                        class="btn btn-primary m-2"
                        v-show="$can('avance-modificar')"
                        v-on:click="guardarHojaMetrado"
                        :disabled="disableHojaMetrado"

                >
                  <i class="fa fa-save"></i> Guardar Hoja de metrado</button>
                <button type="button"
                        class="btn btn-primary m-2"
                        v-show="$can('avance-modificar')"
                        v-on:click="actualizarHojaMetrado"
                        :disabled="disableHojaMetrado"
                >
                  <i class="fa fa-calculator"></i> Calcular</button>
                <button type="button"
                        class="btn btn-primary m-2"
                        v-show="$can('avance-modificar')"
                        v-on:click="insertarFila('Actividad')"
                        :disabled="disableHojaMetrado"
                >
                  <i class="fa fa-plus"></i> Actividad</button>

                <button type="button"
                        class="btn btn-primary m-2"
                        v-show="$can('avance-modificar')"
                        v-on:click="insertarFila('Personal')"
                        :disabled="disableHojaMetrado"
                >
                  <i class="fa fa-plus"></i> Personal</button>
                <button type="button"
                        class="btn btn-primary m-2"
                        v-show="$can('avance-modificar')"
                        v-on:click="insertarFila('Act. Contributiva')"
                        :disabled="disableHojaMetrado"
                >
                  <i class="fa fa-plus"></i> Act. Contributivas</button>
                <button type="button"
                        class="btn btn-primary m-2"
                        v-show="$can('avance-modificar')"
                        v-on:click="insertarFila('')"
                        :disabled="disableHojaMetrado"
                >
                  <i class="fa fa-plus"></i>Espacio</button>
              </div>

              <div class="col-md-2">
                <h6><strong>Total Actividades:</strong> {{this.total_parciales}}</h6>
                <h6><strong>Total Horas:</strong> {{this.total_horas}}</h6>
                <br>
              </div>
            </div>
            <div class="row">

            </div>
            <hot-table :settings="hotSettings"  ref="hotTableComponent" ></hot-table>

          </b-tab>
          <b-tab title="Fotos">
            <div class="row">
              <button type="button" class="btn btn-primary m-2" v-show="$can('avance-modificar')" v-on:click="abrirCarga">Cargar fotos</button>
            </div>
            <div class="row font-size-12">
              <table class="table">
                <thead>
                <th>ID</th>
                <th>Archivos</th>
                <th>Op</th>
                </thead>
                <tbody>
                <tr v-for="(data,index) in data.archivos"  v-bind:key="index">
                  <td>
                    {{ data.id }}
                  </td>
                  <td>
                    <a :href="server + '/storage/' + data.nombre"  target="_blank" >
                      <img :src="server + '/image/' + data.nombre" style="max-width: 200px; height: auto; " />
                    </a>

                  </td>
                  <td>
                    <button
                        v-show="$can('avance-modificar')"
                        class="btn btn-danger btn-icon btn-sm ml-1"
                        v-on:click="borrarArchivo(data.id)" >
                      <i class="fa fa-trash"></i>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>

            </div>

          </b-tab>
        </b-tabs>

        <b-modal
            id="modalUpload"
            scrollable
            title="Subir archivo"
            title-class="font-18"
            size="lg"
            no-close-on-esc
            hide-footer
            centered
        >
          <subirArchivos v-on:upload-complete="uploadComplete" />
        </b-modal>
      </div>
    </div>
  </b-overlay>

</template>

<script>
    import subirArchivos from "@/components/subir-archivos";
    export default {
        name: "partida-avance-info",
        components: {
          subirArchivos,
        },
        methods:{
          insertarFila(tipo){
            this.data.hoja_metrado.push(
                [tipo,"","","","","","",""],
            );
            this.$refs.hotTableComponent.hotInstance.loadData(this.data.hoja_metrado);
            this.renderHojaMetrado();
            this.calcularHojaMetrado();
          },

          renderHojaMetrado(){
            const count_rows=this.$refs.hotTableComponent.hotInstance.countRows();
            for(let row=0;row<count_rows;row++){
              let tipo=this.$refs.hotTableComponent.hotInstance.getDataAtCell(row,0);
              if(tipo==='Personal'){
                this.$refs.hotTableComponent.hotInstance.setCellMeta(row, 2, 'type', 'autocomplete');
                this.$refs.hotTableComponent.hotInstance.setCellMeta(row, 2, 'source', ['Operario', 'Oficial', 'Peon']);
              }
              if(tipo==='Actividad' ||tipo==''){
                this.$refs.hotTableComponent.hotInstance.setCellMeta(row, 2, 'type','text');
              }
            }
            this.$refs.hotTableComponent.hotInstance.render(); // Redibujar la tabla para aplicar los cambios
          },
          calcularHojaMetrado(){
            const count_rows=this.$refs.hotTableComponent.hotInstance.countRows();
            this.total_parciales=0;
            this.total_horas=0;
            for(let row=0;row<count_rows;row++){
              let tipo=this.$refs.hotTableComponent.hotInstance.getDataAtCell(row,0);
              if(tipo==='Personal'){
                let horas_hombre=this.$refs.hotTableComponent.hotInstance.getDataAtCell(row,1);
                if(horas_hombre!=null){
                  let cantidad=this.$refs.hotTableComponent.hotInstance.getDataAtCell(row,3);
                  let horas_hombre_total=parseFloat(horas_hombre)*parseFloat(cantidad);
                  this.total_horas=parseFloat(horas_hombre_total)+parseFloat(this.total_horas);
                  this.$refs.hotTableComponent.hotInstance.setDataAtCell(row,7,horas_hombre_total);
                }
                else
                {
                  this.$refs.hotTableComponent.hotInstance.setDataAtCell(row,7,"");
                }
              }
              if(tipo==='Actividad'){
                let cantidad=this.$refs.hotTableComponent.hotInstance.getDataAtCell(row,3);
                let largo=this.$refs.hotTableComponent.hotInstance.getDataAtCell(row,4);
                let ancho=this.$refs.hotTableComponent.hotInstance.getDataAtCell(row,5);
                let alto=this.$refs.hotTableComponent.hotInstance.getDataAtCell(row,6);
                cantidad =cantidad || 0;
                largo =largo || 0;
                ancho =ancho || 0;
                alto =alto || 0;
                if(largo == 0 && ancho == 0 && alto == 0) {
                  this.$refs.hotTableComponent.hotInstance.setDataAtCell(row,7,"");
                }
                else
                {
                  if(largo===0) largo=1;
                  if(ancho===0) ancho=1;
                  if(alto===0) alto=1;
                  let parcial= parseFloat(cantidad*largo*ancho*alto).toFixed(2);
                  this.$refs.hotTableComponent.hotInstance.setDataAtCell(row,7,parcial);
                  this.total_parciales=parseFloat(this.total_parciales)+parseFloat(parcial);
                }
              }

            }
          },
          actualizarHojaMetrado(){
            this.isLoading=true;
            this.renderHojaMetrado();
            this.calcularHojaMetrado();
            this.isLoading=false;
          },
          guardarHojaMetrado(){
            this.renderHojaMetrado();
            this.calcularHojaMetrado();
            let data_tabla=this.$refs.hotTableComponent.hotInstance.getData()
            if(this.data.id===0){
              this.isLoading=true;
              this.axios.post(process.env.VUE_APP_BACKEND + "/api/avance",
                  {
                    expediente_id:this.data.expediente_id,
                    partida_id:this.data.partida_id,
                    cantidad:this.total_parciales,
                    costo_unitario:this.data.costo_unitario,
                    tipo_costo:this.data.tipo_costo,
                    fecha:this.data.fecha,
                    subtotal:(parseFloat(this.total_parciales)*parseFloat(this.data.costo_unitario)).toFixed(3),
                    hoja_metrado:data_tabla
                  }
              )
                  .then(()=>{
                    this.$emit("registro-completado");
                    //this.cargarAvance();
                  })
                  .catch((r)=>{

                    this.$swal('Cuidado',r.response.data.mensaje,'warning');
                  })
                  .finally(()=>this.isLoading=false)
            }
            else
            {
              this.isLoading=true;
              this.axios.put(process.env.VUE_APP_BACKEND + "/api/avance/"+this.data.id, {
                avance_id:this.data.id,
                expediente_id:this.data.expediente_id,
                partida_id:this.data.partida_id,
                cantidad:this.total_parciales,
                costo_unitario:this.data.costo_unitario,
                tipo_costo:this.data.tipo_costo,
                fecha:this.data.fecha,
                subtotal:(parseFloat(this.total_parciales)*parseFloat(this.data.costo_unitario)).toFixed(3),
                hoja_metrado:data_tabla,
              })
                  .then((response)=>{
                    console.log(response);
                    this.$swal('Ok',"Se guardo correctamente",'success');
                    this.$emit("registro-completado");
                  })
                  .catch((error)=>{
                    if (error.response) {
                      this.$swal('Cuidado',error.response.data.mensaje,'warning');
                    }
                    else
                    {
                      this.$swal('Error',"Server error",'error');
                    }
                  })
                  .finally(()=>this.isLoading=false)
            }


          },
          uploadComplete(files){
            this.isLoading=true;
            this.axios.post(process.env.VUE_APP_BACKEND + "/api/avance/archivos",
                {
                  files:files,
                  avance_id:this.data.id
                })
                .then(()=>{
                  this.$bvModal.hide("modalUpload");
                  this.actualizar();
                })
                .finally(()=>this.isLoading=false)
          },
          abrirCarga(){
            this.$bvModal.show("modalUpload");
          },
          actualizar(){
            this.isLoading=true;
            this.axios.get(process.env.VUE_APP_BACKEND + "/api/avance/"+this.data.id)
                .then((response)=>{
                  this.data=response.data;
                  //this.$bvModal.show("modalVerAvance");
                })
                .finally(()=>this.isLoading=false)
          },
          borrarArchivo(id){
            this.$swal.fire({
              title: '¿Esta seguro?',
              text: "No se puede revertir esta accion!",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#d33',
              cancelButtonColor: '#3085d6',
              confirmButtonText: 'Si, borralo!'
            }).then((result) => {
              if (result.value) {
                this.isLoading=true;
                this.axios.delete(process.env.VUE_APP_BACKEND +'/api/avance/'+this.data.id+'/archivos/'+id)
                    .catch(()=>{
                      this.$swal('error','Error eliminando','error');
                    })
                    .finally(
                        ()=>
                        {
                          this.isLoading=false;
                          this.actualizar();
                        }

                    );
              }
            })
          }
        },
        mounted() {
          this.$refs.hotTableComponent.hotInstance.loadData(this.data.hoja_metrado);
          this.renderHojaMetrado();
          this.calcularHojaMetrado();
        },
        props: {
              data:{
                  type:Object
              }
          },
        data() {
            return {
              isLoading:false,
              total_parciales:0,
              total_horas:0,
              server:process.env.VUE_APP_BACKEND,
              disableHojaMetrado:false,
              tabIndex:0,
              hotSettings: {
                width: 800,
                height: 300,
                colWidths:[140,60,280,60,60,60,60,60],
                colHeaders: ['Tipo', 'HH', 'Descripción', 'Cantidad', 'Largo', 'Ancho', 'Alto', 'Parcial'],
                data: [
                    ['','','','','','','','']
                ],
                columns: [
                  {
                    type: 'dropdown',
                    source: ['Actividad', 'Personal','Act. Contributiva']
                  }, // Primera columna (sin cambios)
                  {type: 'numeric'}, // Segunda columna como numérica
                  {}, // Tercera columna (sin cambios)
                  {type: 'numeric' },
                  {type: 'numeric' },
                  {type: 'numeric' },
                  {type: 'numeric' },
                  {type: 'numeric' },

                ],
                //autoWrapRow: true,
                //autoWrapCol: true,
                licenseKey: 'non-commercial-and-evaluation',
                contextMenu: true,
                cells: function (row, col) {
                  const cellProperties = {};
                  if (col === 7) {
                    cellProperties.readOnly = true;
                  }
                  return cellProperties;
                },
                afterChange:(changes)=>{
                  //console.log(changes);
                  changes?.forEach(([row, prop, , newValue]) => {
                    if(prop===0){
                      if(newValue==="Personal"){
                        this.$refs.hotTableComponent.hotInstance.setCellMeta(row, 2, 'type', 'autocomplete');
                        this.$refs.hotTableComponent.hotInstance.setCellMeta(row, 2, 'source', ['Operario', 'Oficial', 'Peon']);
                        /*this.$refs.hotTableComponent.hotInstance.setDataAtCell(row,4,"");
                        this.$refs.hotTableComponent.hotInstance.setDataAtCell(row,5,"");
                        this.$refs.hotTableComponent.hotInstance.setDataAtCell(row,6,"");
                        this.$refs.hotTableComponent.hotInstance.setCellMeta(row, 4, 'readOnly', true);
                        this.$refs.hotTableComponent.hotInstance.setCellMeta(row, 5, 'readOnly', true);
                        this.$refs.hotTableComponent.hotInstance.setCellMeta(row, 6, 'readOnly', true);*/
                      }
                      if(newValue==="Actividad"){
                        this.$refs.hotTableComponent.hotInstance.setCellMeta(row, 2, 'type', 'text');
                        /*this.$refs.hotTableComponent.hotInstance.setCellMeta(row, 4, 'readOnly', false);
                        this.$refs.hotTableComponent.hotInstance.setCellMeta(row, 5, 'readOnly', false);
                        this.$refs.hotTableComponent.hotInstance.setCellMeta(row, 6, 'readOnly', false);*/
                      }
                      if(newValue===""){
                        this.$refs.hotTableComponent.hotInstance.setCellMeta(row, 2, 'type', 'text');
                      }
                      this.$refs.hotTableComponent.hotInstance.render(); // Redibujar la tabla para aplicar los cambios
                    }
                    if(prop === 1 ||prop === 3||prop === 4||prop === 5||prop === 6){
                      this.calcularHojaMetrado();
                    }
                  });

                },

              }
            }
        },


    }
</script>

<style scoped>

</style>